const md = `# Dashboard Overview

The top nav has six destinations.  Here's where each one lives and what
you do there.

## Workflows

The **library** — every demo we know how to run.  Each row shows its
tags, last successful run, and a **Run** button.  Builders and admins
get an **Edit** button as well.

## Demo Runs

A live, paginated feed of recent runs.  Each row links to a
**run-detail page** with the Playwright video, screenshots in step
order, the generated narration, the voiceover audio, and (if the
auto-pipeline ran) a single stitched MP4 you can download.

## History

A heavier, searchable view of *all* runs you have access to.  Filter by
workflow, status, tag, run number, persona, or folder.  This is the
right place when a customer asks "did you ever demo the catalog flow
to Acme?".

## Folders

User-defined groupings.  Drop runs you want to keep together — e.g. *Q4
SKO Demos*, *Acme proposal v3*, *Reusable assets* — into a folder, and
share the whole folder with one link.

## Shares (Admins only)

The list of every public share token issued, who owns it, what it
points at, and when it expires.  Revoke any link from here.

## Users (Admins only)

Role assignment + audit trail.  Promote a colleague to Builder or
demote a Viewer here.
`;

export default md;
